import { createEvent, sample } from 'effector'
import { OfferLinkFormItem } from './types'
import { fx } from '../../../../../../libs'
import { $params } from '../../../../../../features/router'

export const submitCreateOfferLink = createEvent<OfferLinkFormItem>()

export const submitUpdateOfferLink =
  createEvent<Omit<OfferLinkFormItem, 'lang'>>()

export const createOfferLink = fx<OfferLinkFormItem, void>({
  method: 'POST',
  url: '/partner/material/offer_link',
})

export const updateFileManagerFile = fx<Omit<OfferLinkFormItem, 'lang'>, void>({
  method: 'PUT',
  url: '/partner/material/offer_link/${id}',
})

sample({
  clock: submitCreateOfferLink,
  source: $params,
  fn: (params, offerLink) => {
    let id
    if (params) {
      id = params.offerID
    }

    return {
      url: `/partner/material/offer_link`,
      body: { ...offerLink, offerId: Number(id) },
    }
  },
  target: createOfferLink,
})

sample({
  clock: submitUpdateOfferLink,
  fn: (offerLink) => {
    return {
      url: `/partner/material/offer_link/${offerLink.id}`,
      body: { ...offerLink },
    }
  },
  target: updateFileManagerFile,
})
